import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() texto: string = 'Botão';
  @Input() classe: string = '';
  @Input() disabled: boolean = false;
  @Input() backgroundColor?: string;
  @Input() borderColor?: string;
  @Input() textColor?: string;
  @Input() variant: 'filled' | 'outline' = 'filled';
  @Output() onClick = new EventEmitter<void>();

  handleClick() {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }

  get buttonStyles() {
    const styles: { [key: string]: string } = {};
    
    if (this.variant === 'outline') {
      if (this.borderColor) {
        styles['border-color'] = this.borderColor;
      }
      if (this.textColor) {
        styles['color'] = this.textColor;
      }
      styles['background-color'] = 'transparent';
      styles['border-style'] = 'solid';
      styles['border-width'] = '1px';
    } else {
      if (this.backgroundColor) {
        styles['background-color'] = this.backgroundColor;
      }
      if (this.textColor) {
        styles['color'] = this.textColor;
      }
    }
    
    return styles;
  }
}

